import { render, staticRenderFns } from "./usernameChange.vue?vue&type=template&id=bace5bba&"
import script from "./usernameChange.vue?vue&type=script&lang=js&"
export * from "./usernameChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports